import { useEffect, useState } from "react";

type TwBreakpointKey = "sm" | "md" | "lg" | "xl" | "2xl";

const TW_BREAKPOINTS: Record<TwBreakpointKey, string> = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
};

function useTwIsWidthMin(breakpoint: TwBreakpointKey) {
  const value = TW_BREAKPOINTS[breakpoint];

  const [isBelowBreakpoint, setIsBelowBreakpoint] = useState(() => {
    if (typeof window === "undefined") return undefined;
    return !window.matchMedia(`(min-width: ${value})`).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${value})`);
    const onChange = () => setIsBelowBreakpoint(!mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [value]);

  return !!isBelowBreakpoint;
}

export function useTwIsMobile() {
  return useTwIsWidthMin("md");
}
